import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import { ThemeProvider } from './ThemeContext'
import MainLayout from './Components/MainLayout/MainLayout'
import LoginPage from './Components/Login/Login'
import Dashboard from './Components/pages/Dashboard/Dashboard'
import AdminProfile from './Components/pages/AdminProfile/AdminProfile'
import Customer from './Components/pages/Customer/Customer'
import ItemManagement from './Components/pages/ItemManagement/ItemManagement'
import Transaction from './Components/pages/Transaction/Transaction'
import Report from './Components/pages/Report/Report'
import Analytics from './Components/pages/Analytics/Analytics'
import PushNotification from './Components/pages/PushNotification/PushNotification'
import FAQs from './Components/pages/FAQs/FAQs'
import Feedback from './Components/pages/Feedback/Feedback'
import Support from './Components/pages/Support/Support'
import Subscription from './Components/pages/Subscription/Subscription'
import Invoice from './Components/pages/Invoice/Invoice'
import WelcomeModal from './Components/common/WelcomeModal/WelcomeModal'
import Product from './Components/pages/Product/Product'
import Order from './Components/pages/Order/Order'
import Category from './Components/pages/Category/Category'
import Policies from './Components/pages/Policies/Policies'
import Contact from './Components/pages/Contact/Contact'
import Collection from './Components/pages/Collection/Collection'
import PromoBanner from './Components/pages/PromoBanner/PromoBanner'
import WatchBuy from './Components/pages/Watchbuy/WatchBuy'
import FeaturedLogo from './Components/pages/Featuredlogo/Featuredlogo'

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<LoginPage />} />
          <Route element={<MainLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<><Dashboard /><WelcomeModal /></>} />
            <Route path="admin-profile" element={<AdminProfile />} />
            <Route path="customer" element={<Customer />} />
            <Route path="product" element={<Product />} />
            <Route path="order" element={<Order />} />
            <Route path="item-management" element={<ItemManagement />} />
            <Route path="transaction" element={<Transaction />} />
            <Route path="report" element={<Report />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="push-notification" element={<PushNotification />} />
            <Route path="faqs" element={<FAQs />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="support" element={<Support />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="invoice" element={<Invoice />} />
            <Route path="category" element={<Category />} />
            <Route path="return-policy" element={<Policies />} />
            <Route path="contact" element={<Contact />} />
            <Route path="/collections" element={<Collection />} />
            <Route path="/promo-banner" element={<PromoBanner />} />
            <Route path="/watch-buy" element={<WatchBuy />} />
            <Route path="/featured-in" element={<FeaturedLogo />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}